import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=9150073a&scoped=true"
import script from "./GameInfo.vue?vue&type=script&lang=js"
export * from "./GameInfo.vue?vue&type=script&lang=js"
import style0 from "./GameInfo.vue?vue&type=style&index=0&id=9150073a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9150073a",
  null
  
)

export default component.exports